export const LandingPage4Template = {
    slots: ['SlbLandingPagesContainerSlot'],
};

export const LandingPage5Template = {
    slots: ['SlbLandingPageThankYouContainerSlot']
}